export enum CalculatePriceTranslation {
  ARRIVAL = "LABEL_TO",
  CALCULATE_PRICE = "LABEL_CALCULATE_PRICE",
  DEPARTURE = "LABEL_FROM",
  DESCRIPTION = "TEXT_PRICE_REQUEST_DESCRIPTION",
  DETAILS = "LABEL_DETAILS",
  FRAGILE = "LABEL_FRAGILE",
  HAZARDOUS = "LABEL_HAZARDOUS",
  PAGE_TITLE = "LABEL_PRICE_REQUEST",
  PLACEHOLDER_GROSS_WEIGHT = "PLACEHOLDER_GROSS_WEIGHT",
  PLACEHOLDER_VOLUME = "PLACEHOLDER_ENTER_VOLUME",
  PLACEHOLDER_TOWN_CITY = "PLACEHOLDER_TOWN_CITY",
  PRICE_INC_VAT = "LABEL_PRICE_INC_VAT",
  PRICE_NOT_FOUND = "TEXT_PRICE_NOT_FOUND",
  ROUTE_SECTION = "LABEL_ROUTE",
  SPECIAL_HANDLING = "LABEL_SPECIAL_HANDLING",
  TEMPERATURE = "LABEL_TEMPERATURE_CONTROLLED",
  SELECTED_COMPANY = "TEXT_SELECTED_COMPANY",
  TEXT_CONTACT_CUSTOMER_SERVICE = "TEXT_CONTACT_CUSTOMER_SERVICE",
  USE_COMPANY = "TEXT_USE_COMPANY",
  VOLUME = "LABEL_VOLUME",
  VOLUME_TOOLTIP = "INFO_VOLUME",
  WEIGHT = "LABEL_GROSS_WEIGHT",
  WEIGHT_TOOLTIP = "INFO_GROSS_WEIGHT",
  PRICE_DISCLAIMER = "TEXT_PRICE_DISCLAIMER",
  PRICE_REQUEST_DISCLAIMER = "TEXT_DOMESTIC_PRICE_DISCLAIMER",
  RESULTS = "LABEL_RESULTS",
}

export enum ErrorTranslation {
  SAME_LOCATION = "ERROR_SAME_SERVICE_AREA",
}

export const InputConstraint = {
  MIN_INPUT_WEIGHT: 1,
  MAX_INPUT_WEIGHT: 50000,
  MIN_INPUT_VOLUME: 0.003,
  MAX_INPUT_VOLUME: 99.999,
} as const;
